import React from "react";
import * as Yup from "yup";
import { useParams, Link, useHistory } from "react-router-dom";
import { Row, Col, Spinner, Card, Label, Button } from "reactstrap";
import { InputTextarea } from "primereact/inputtextarea";
import EditorContainer from "../../components/EditorContainer";
import { getNotification, updateNotification, notify } from "../../api/servicenotification";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const schema = () =>
    Yup.object({
        attributes: Yup.object({
            notes: Yup.string().required("Inserire i dettagli")
        })
    });

const ServiceNotificationEditor = ({ activeTenant }) => {

    const { id } = useParams();
    const [notification, setNotification] = React.useState();
    const [loading, setLoading] = React.useState(false);

    const { push } = useHistory();

    const onLoad = async id => {
        const ntf = await getNotification(id);
        setNotification(ntf);
        return ntf;
    };

    const sendNotification = () => {
        if (confirm(`Confermi l'invio di una email di notifica?`)) {
            try {
                setLoading(true);
                notify(notification, "email");
            } finally {
                setLoading(false);
            }
        }
    }

    const closeService = async entity => {
        try {
            setLoading(true);
            const result = await updateNotification(entity);
            setNotification(result)
            return result;
        } finally {
            setLoading(false);
            push("/tenant/service-notifications");
        }
    };

    const onUpdate = async entity => {
        const result = await updateNotification(entity);
        return result;
    };

    const onChangeNotes = (changedProps, attributes, containerHandleChange) => {
        const newAttributes = { ...attributes, ...changedProps };
        containerHandleChange("attributes", { target: { value: newAttributes } });
    };

    return (
        <EditorContainer
            key={id ? `${id}-svcnotif` : "new-svcnotif"}
            canSave={true}
            schema={schema}
            onCreate={() => null}
            readOnly
            onUpdate={onUpdate}
            onLoad={onLoad}
            optionalNav={{ link: `/tenant/service-notifications`, text: "Richiami" }}
            redirRoot={`/tenant/service-notifications`}
            title={el => `${el && el.attributes ? el.attributes.name : "NUOVO RICHIAMO"}`}
            children={(frmProps, containerHandleChange) => {
                const attributes = frmProps.values["attributes"] || {
                    notes: ""
                };

                return (
                    <Row>
                        {notification ? (
                            <Col xs="12">
                                <Card body color="default">
                                    <Row>
                                        {notification && notification.status === "chiuso" && <Col xs="12">
                                            <strong className="text-primary">Data chiusura richiamo: </strong>
                                            {moment(notification.closedat).format("DD/MM/YYYY")}
                                        </Col>}
                                        <Col sm="6" xs="12" md="4">
                                            <strong className="mt-1 d-block">Cliente:</strong>
                                            <Label className="mt-1 d-block h5">{`${notification.attributes.name}`}</Label>
                                            <Label className="mt-1 d-block h5">{`Tel.: ${notification.attributes.phone}`}</Label>
                                            <Label className="mt-1 d-block h5">{`Email: ${notification.attributes.email}`}</Label>
                                        </Col>
                                        <Col sm="6" xs="12" md="4">
                                            <strong className="mt-1 d-block">Veicolo:</strong>
                                            <Label className="mt-1 d-block h5">{`Modello: ${notification.attributes.preparation || notification.attributes.make} ${notification.attributes.model}`}</Label>
                                            <Label className="mt-1 d-block h5">{`Targa: ${notification.attributes.plate} Km: ${notification.attributes.kmTot}`}</Label>
                                            <Label className="mt-1 d-block h5">{`Ultimo tagliando eseguito il: ${moment(notification.attributes.lastExecuted).format("DD/MM/YYYY")}`}</Label>
                                        </Col>
                                        <Col sm="6" xs="12" md="4">
                                            <strong className="mt-1 d-block">Scadenze previste dal modello tagliando applicato:</strong>
                                            <Label className="mt-1 d-block h5">{`Km: ${notification.attributes.modelKm}`}</Label>
                                            <Label className="mt-1 d-block h5">{`Mesi: ${notification.attributes.modelDuration || ' - '}`}</Label>
                                        </Col>
                                        <Col xs="12">
                                            <Link className="btn btn-success" to={`/tenant/services/${notification.model_id}`} ><FontAwesomeIcon icon="file-alt" className="mr-2" />Visualizza Modello Tagliando applicato</Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ) : null}
                        <Col xs="12">
                            <strong className="mt-2">Note:</strong>
                            <InputTextarea
                                disabled={notification && notification.status === "chiuso"}
                                value={attributes.notes || ""}
                                style={{ width: "100%" }}
                                onChange={e =>
                                    onChangeNotes({ notes: e.target.value }, attributes, containerHandleChange)
                                }
                            />
                        </Col>
                        <Col xs="12">
                            <div className="float-right mt-2">
                                {notification && notification.status === "aperto" && (
                                    <React.Fragment>
                                        <Button
                                            disabled={loading}
                                            className="mr-2"
                                            color="secondary"
                                            label="Invia Notifica"
                                            onClick={() => sendNotification()}
                                        >
                                            <FontAwesomeIcon className="mr-2" spin={loading ? true : false} icon={loading ? "sync-alt" : "envelope"} />Invia Notifica</Button>
                                        <Button
                                            disabled={loading}
                                            className="mr-2"
                                            color="primary"
                                            onClick={() => closeService(notification)}
                                        >
                                            <FontAwesomeIcon className="mr-2" spin={loading ? true : false} icon={loading ? "sync-alt" : "times"} />Chiudi Richiamo</Button>
                                    </React.Fragment>)}
                                <Button
                                    onClick={() => push('/')}
                                    color="warning"
                                    className="btn btn-warning float-right"
                                >
                                    <FontAwesomeIcon icon="reply" /> Torna
                                </Button>
                            </div>
                        </Col>
                    </Row>
                );
            }}
            renderDealer={() =>
                activeTenant ? (
                    <React.Fragment>
                        <Card body className="rounded bg-secondary mb-2">
                            <Row>
                                <Col sm="4" xs="12">
                                    <strong>Dealer: </strong>
                                    <Label className="h5">{activeTenant.name}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="4">
                                    <strong>Telefono: </strong>
                                    <Label className="h5">{activeTenant.phone}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="4">
                                    <strong>Email: </strong>
                                    <Label className="h5">{activeTenant.email}</Label>
                                </Col>
                            </Row>
                        </Card>
                    </React.Fragment>
                ) : (
                        <Spinner style={{ width: "3rem", height: "3rem" }} type="grow" />
                    )
            }
        />
    );
};
export default ServiceNotificationEditor;
